<template lang="pug">
.login
    el-form(:model="form", :rules="rules", ref="twoFactorAuthForm", @submit.native.prevent="handleSubmit")
        el-form-item(label='Enter two-factor verification code:', prop="code")
            el-input(v-model="form.code")
        el-button(type="primary", native-type="confirm", :loading="loading") Continue
</template>

<script>
export default {
	name: "TwoFactorAuth",
	props: {
		user: {
			type: Object,
			required: true
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	data: () => ({
		form: {
			code: null
		},
		rules: {
			code: [{ required: true, trigger: "blur", message: "Code is required" }]
		}
	}),
	methods: {
		async handleSubmit() {
			try {
				await this.$refs.twoFactorAuthForm.validate();

				this.$emit("submitted", this.form.code.toString());
			} catch (error) {
				this.$message.error("Two Factor Verification code required");
			}
		}
	}
};
</script>
